import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BackendServiceService } from './backend-service.service';

@Injectable({
  providedIn: 'root'
})
export class PostsService {

  constructor(private httpClient: HttpClient, private backendService: BackendServiceService) { }

  saveDetails(details: any) {
    let token = localStorage.getItem("token");
    return this.httpClient.post<any>(this.backendService.apiSystemAdminURL + 'posts/add/post?mds=' + token, details);
  }

  getAllDetails() {
    let token = localStorage.getItem("token");
    return this.httpClient.get<any>(this.backendService.apiSystemAdminURL + 'posts/getall/posts?mds=' + token);

  }

  getDetailsById(newsId: any) {
    let token = localStorage.getItem("token");
    return this.httpClient.get<any>(this.backendService.apiSystemAdminURL + 'posts/getbyid/post?id=' + newsId + '&mds=' + token);
  }

  editImage(details: any) {
    let token = localStorage.getItem("token");
    return this.httpClient.post<any>(this.backendService.apiSystemAdminURL + 'posts/edit/postimage?mds=' + token, details);
  }

  editDetails(details: any) {
    let token = localStorage.getItem("token");
    return this.httpClient.post<any>(this.backendService.apiSystemAdminURL + 'posts/edit/postdetails?mds=' + token, details);
  }

  deletePost(id:any){
    let token = localStorage.getItem("token");
    return this.httpClient.get<any>(this.backendService.apiSystemAdminURL + 'posts/delete/post?mds=' + token+'&id='+id);
  }

  //***************** Other Details ************ */
  saveOtherDetails(details: any) {
    let token = localStorage.getItem("token");
    return this.httpClient.post<any>(this.backendService.apiSystemAdminURL + 'posts/add/post/otherdetails?mds=' + token, details);
  }


  getIOtherDetailsByMainId(id: any) {
    let token = localStorage.getItem("token");
    return this.httpClient.get<any>(this.backendService.apiSystemAdminURL + 'posts/getallotherpost/posts?id=' + id + '&mds=' + token);
  }

  //Sub Details
  getOtherSubDetailsById(id: any) {
    let token = localStorage.getItem("token");
    return this.httpClient.get<any>(this.backendService.apiSystemAdminURL + 'posts/getotherpostdetails/post?id=' + id + '&mds=' + token);
  }


  editOtherDetails(details: any,id:any) {
    let token = localStorage.getItem("token");
    return this.httpClient.post<any>(this.backendService.apiSystemAdminURL + 'posts/edit/postothersubdetails?mds=' + token+'&id='+id, details);
  }


  editOtherImage(details: any) {
    let token = localStorage.getItem("token");
    return this.httpClient.post<any>(this.backendService.apiSystemAdminURL + 'posts/edit/postotherimage?mds=' + token, details);
  }

  deleteOtherImage(id: any) {
    let token = localStorage.getItem("token");
    return this.httpClient.get<any>(this.backendService.apiSystemAdminURL + 'posts/delete/postotherimage?mds=' + token+'&id='+id);
  }

  getAllPostDetails() {
    let token = localStorage.getItem("token");
    return this.httpClient.get<any>(this.backendService.apiLocalUrl + 'posts/getallposts?mds=' + token);
  }

   getPostDetailsByUser(id:any){
    let token = localStorage.getItem("token");
    return this.httpClient.get<any>(this.backendService.apiLocalUrl+'posts/getpostdetailsbyuser?mds='+token+'&id='+id);
  }

   getPostDetailsByKey(keywords:any){
    let token = localStorage.getItem("token");
    return this.httpClient.get<any>(this.backendService.apiLocalUrl+'posts/getpostdetailsbyKeywords?mds='+token+'&keywords='+keywords);
  }

   

    getPostOtherDetailsByUser(id:any){
    let token = localStorage.getItem("token");
    return this.httpClient.get<any>(this.backendService.apiLocalUrl+'posts/getpostotherdetailsbyuser?mds='+token+'&id='+id);
  }
}


